import React from 'react';
import Section from '../Layout/Section/Section';
import InnerContainer from '../Layout/InnerContainer/InnerContainer';
import PreviewCompatibleImage from '../Utils/PreviewCompatibleImage';

import './small-boxes.scss';

function renderImages(images) {
  let ImagesHTML = [];
  if (images) {
    images.forEach(image => {
      ImagesHTML.push(
        <PreviewCompatibleImage customClass="small-boxes__container__image" imageInfo={image.image} alt="image" />
      )
    })
    return ImagesHTML
  }
}

function renderImage(imageData) {
  if(imageData) {
    return (
      <PreviewCompatibleImage
        customClass={ "icon" }
        imageInfo={imageData}
        alt="icon"
      />
    )
  }
}

function renderCopy(copy) {
  if(copy && copy.caption) {
    return <p className="small-boxes__container__caption">{copy.caption}</p>;
  }
  if(copy && copy.body) {
    return <p className="body-copy">{copy.body[0].line}</p>;
  }
}

function renderBlock(blockContent) {
  const allBlocksHTML = [];
  
  if (blockContent && blockContent[0]) {
    blockContent.forEach((block, i) => {
      let count = i;
      let blockHTML = [];
      if (block.image) {
        blockHTML.push(<PreviewCompatibleImage key={count} customClass="small-boxes__container__image" imageInfo={block.image} alt="image" />)
        count++;
      }
  
      if (block.headlines && block.headlines[0]) {
        blockHTML.push(<h3 key={count} className="headline">{block.headlines[0].line}</h3>);
        count++;
      }
      if (block.leader) {
        blockHTML.push(<h4 key={count} className="leader">{block.leader}</h4>);
        count++;
      }
      
      if (block.body && block.body[0]) {
        blockHTML.push(<p key={count} className="body-copy">{block.body[0].line}</p>);
        count++;
      }
  
      allBlocksHTML.push(<div key={count} className="block">{blockHTML}</div>);
    })
  }

  return allBlocksHTML;
}

const SmallBoxes = ({id, copy, gridImages, variant}) => {
  const modClass = gridImages ? `show-${gridImages.length}` : '';
  
  return (
    <Section id={id} customClass={["small-boxes", variant]}>
      <InnerContainer customClass={["small-boxes__container", `${modClass}`]}>
        {renderBlock(gridImages)}
        {renderCopy(copy)}
      </InnerContainer>
    </Section>
  )
}

export default SmallBoxes;
